import React from 'react';

const RecruitsEditForm = ({ events }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return `締め切り：${date.getMonth() + 1}月${date.getDate()}日(${['日', '月', '火', '水', '木', '金', '土'][date.getDay()]}) ${date.getHours()}:${('0' + date.getMinutes()).slice(-2)}`;
  };

  const recruitList = events.map((event) => ({
    id: event.id,
    title: event.title,
    circle_id: event.circle_id,
    deadline: formatDate(event.application_due_date),
    buttonText: 'イベントページを見る',
    buttonLink: `/events/${event.id}`,
  }));

  return (
    <div className="profile-details">
      <div className="p-2 mb-2">
        <div className="row align-items-center">
          <div className="col-12 d-flex align-items-center">
          <h2
            className="pl-2_5 mb-0 text-fw-bold h2 h2--extend -member2"
            style={{ fontSize: '18px' }}
            >
            Myイベント一覧
          </h2>
          </div>
        </div>
      </div>
      <div className="recruitment-list text-center my-4">
        <button
          style={{
            border: '2px solid #FF4D5B',
            backgroundColor: 'white',
            color: '#FF4D5B',
            padding: '14px 100px',
            borderRadius: '10px',
            fontSize: '14px',
            cursor: 'pointer',
          }}
          onClick={() => (window.location.href = `/events/new`)}
        >
          {/* ＋募集項目を追加 */}
          ＋イベントを主催する
        </button>
      </div>
      <div className="recruitment-list col-lg-12">
        {recruitList.map((event) => (
          <div
            key={event.id}
            style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              marginBottom: '15px',
              padding: '15px',
              backgroundColor: '#fff',
            }}
          >
            <h4
              style={{
                fontSize: '16px',
                fontWeight: 'bold',
                marginBottom: '10px',
              }}
            >
              {event.title}
            </h4>
            <p style={{ fontSize: '14px', color: '#555' }}>{event.deadline}</p>
            <button
              style={{
                border: '2px solid #FF4D5B',
                backgroundColor: 'white',
                color: '#FF4D5B',
                padding: '7px 20px',
                borderRadius: '10px',
                fontSize: '14px',
                cursor: 'pointer',
              }}
              onClick={() => (window.location.href = `/circle/${event.circle_id}/events/${event.id}`)}
            >
              {event.buttonText}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecruitsEditForm;